import React from "react";
import { EALinkData } from "../../../../../network/api/EALinkData";


export default function ClientsTabCard({ items, tab = "clients", setEALinkList , setErrorMessage, setIsLoading}) {

    const handleDeleteLink = async (linkId) => {
        setIsLoading(true);
        setErrorMessage(null);
        try {
            const response = await EALinkData({ method: "DELETE", id: linkId });
            if (response.status === "success") {
                setEALinkList((prev) => prev.filter((link) => link.id !== linkId));
                setErrorMessage({ status: "success", message: response.message });
            } else {
                setErrorMessage({ status: "danger", message: response.message });
            }
        } catch (error) {
            setErrorMessage({ status: "danger", message: error.message });
        } finally {
            setIsLoading(false);
        }
    }

    const handleUpdateLink = async (linkId, status) => {
        setIsLoading(true);
        setErrorMessage(null);
        try {
            const response = await EALinkData({ method: "PUT", formData: {id:linkId, status: status } });
            if (response.status === "success") {
                setEALinkList((prev) => prev.map((link) => (link.id === linkId ? { ...link, status } : link)));
                setErrorMessage({ status: "success", message: response.message });
            } else {
                setErrorMessage({ status: "danger", message: response.message });
            }
        } catch (error) {
            setErrorMessage({ status: "danger", message: error.message });
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <>
            {items.length === 0 ? (
                <div className="text-center p-5">
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/4076/4076505.png"
                        alt="No Data"
                        style={{ width: "120px", opacity: 0.5 }}
                    />
                    <p className="mt-3 text-muted">No EA Links Found.</p>
                </div>
            ) : (
                items.map((item, index) => {
                    const { client_ea_details, host_ea_details, created, status } = item;
                    const statusBadge = {
                        approved: "primary",
                        pending: "warning",
                        rejected: "danger"
                    };
                    const primaryEA = tab === "clients" ? client_ea_details : host_ea_details;

                    return (
                        <div className={`card rounded border-bottom border-${statusBadge[status]} mb-3`} key={item.id}>

                            <div className="card-body d-flex align-items-start">
                                {primaryEA?.image_url && (
                                    <img
                                        src={primaryEA?.image_url}
                                        alt="EA"
                                        style={{ width: 60, height: 60 }}
                                        className="me-3 rounded-circle object-fit-cover"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg";
                                        }}
                                    />)}
                                <div className="flex-grow-1">
                                    <h6 className="mb-1">
                                        {status === "pending" ? (
                                            <>
                                                {client_ea_details.name} is requesting to link with <b>{host_ea_details.name}</b>
                                            </>
                                        ) : status === "approved" ? (
                                            <>
                                                {client_ea_details.name} linked to <b>{host_ea_details.name}</b>
                                            </>
                                        ) : (
                                            <>
                                                {client_ea_details.name} was rejected from linking to <b>{host_ea_details.name}</b>
                                            </>
                                        )}
                                    </h6>
                                    <p className="mb-1">
                                        Linked since: {created}
                                        <span className={`badge ms-2 badge-${statusBadge[status]}`}>{status}</span>
                                    </p>
                                    <p className="mb-1">EA Code: {primaryEA.secret_code}</p>
                                    {(tab === "hosts" && status !== "approved") ? <></> : (
                                        <div className="d-flex align-items-center">
                                            {primaryEA.owner?.image && (
                                                <img
                                                    src={primaryEA.owner?.image}
                                                    alt="Owner"
                                                    style={{ width: 30, height: 30 }}
                                                    className="me-2 rounded-circle object-fit-cover"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg";
                                                    }}
                                                />)}
                                            <div>
                                                <small>{primaryEA.owner?.displayname}</small><br />
                                                <small>{primaryEA.owner?.email}</small><br />
                                                <small>{primaryEA.owner?.phone}</small>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="mt-3 d-flex gap-2 flex-wrap">
                                    {status === "approved" && (
                                        <div>
                                            <button className="btn btn-sm btn-warning" title="Unlink EA" data-bs-toggle="tooltip" onClick={() => handleDeleteLink(item.id)}>
                                                <i className="fas fa-unlink me-1"></i> Unlink EA
                                            </button>
                                        </div>
                                    )}
                                    {status === "pending" && (
                                        (tab === "hosts" && (
                                            <div>
                                                <button className="btn btn-sm btn-warning" title="Unlink EA" data-bs-toggle="tooltip" onClick={() => handleDeleteLink(item.id)}>
                                                    <i className="fas fa-unlink me-1"></i> Unlink EA
                                                </button>
                                            </div>
                                        ))
                                        || (tab === "clients" && (
                                            <div className="d-flex gap-2">
                                                <button className="btn btn-sm btn-success" title="Approve" data-bs-toggle="tooltip" onClick={() => handleUpdateLink(item.id, "approved")}>
                                                    <i className="fas fa-check me-1"></i>
                                                </button>
                                                <button className="btn btn-sm btn-danger" title="Reject" data-bs-toggle="tooltip" onClick={() => handleUpdateLink(item.id, "rejected")}>
                                                    <i className="fas fa-times me-1"></i>
                                                </button>
                                            </div>
                                        ))
                                    )}

                                    {status === "rejected" && tab === "clients" && (
                                        <div>
                                            <button className="btn btn-sm btn-danger" title="Delete Link" data-bs-toggle="tooltip" onClick={() => handleDeleteLink(item.id)}>
                                                <i className="fas fa-trash me-1"></i>Delete
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })
            )}
        </>
    );
}